<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard>
        <CCardHeader>
            This page calls API from http://localhost:5050/api/values        
        </CCardHeader>
        <CCardBody>
          {{data}}
        </CCardBody>
        <CCardFooter>
          <CButton color="primary" @click="goBack">Back</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Api from '../../services/ApiService'

export default {
  name: 'Test',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.usersOpened = from.fullPath.includes('users')
    })
  },
  mounted() {
      this.getData();
  },
  data () {
    return {
      api: new Api(),
      data: null,
      usersOpened: null
    }
  },
  computed: {
    
  },
  methods: {
    async getData() {
        let self = this
        let result =  await this.api.getAll('values')
        self.data = result
    },
    goBack() {
      this.usersOpened ? this.$router.go(-1) : this.$router.push({path: '/users'})
    }
  }
}
</script>
